import React, { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import FeedbackButton from './components/FeedbackButton';
import ServerStatusToast from './components/ServerStatusToast';
import './api';
import './theme.css';
import { initializeTheme } from './themeUtils';

// Lazily load large application bundles so the landing page doesn't
// immediately execute code that fetches user information.
const LandingPage = lazy(() => import('./LandingPage'));
const OnboardingPage = lazy(() => import('./OnboardingPage'));
const LoginPage = lazy(() => import('./LoginPage'));
const SignupPage = lazy(() => import('./SignupPage'));
const LoggedInPage = lazy(() => import('./LoggedInPage'));
const TermsPage = lazy(() => import('./TermsPage'));

initializeTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <BrowserRouter>
        {/* Suspense ensures the landing page shows quickly without executing */}
        <ErrorBoundary>
          <FeedbackButton />
          <ServerStatusToast />
          <Suspense fallback={<div>Loading...</div>}>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="/logged-in" element={<LoggedInPage />} />
              <Route path="/onboarding" element={<OnboardingPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/" element={<LandingPage />} />
            </Routes>
          </Suspense>
        </ErrorBoundary>
      </BrowserRouter>
  </React.StrictMode>
);
